module.exports = __webpack_public_path__ + "img/sum-and-substance.1407167b.svg";